import EmptyState from "ds/components/EmptyState";
import { EmptystateShareColored } from "components/icons/generated";
import Box from "ds/components/Box";

const ApiKeyRolesEmpty = () => {
  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState title="API key doesn't have any roles assigned yet" icon={EmptystateShareColored} />
    </Box>
  );
};

export default ApiKeyRolesEmpty;